import { useState, useEffect } from 'react';
import axios from 'axios';

const LiveDataQuery = () => {
  const [liveData, setLiveData] = useState(() => {
    // Load initial data from localStorage if available
    const storedData = localStorage.getItem('liveData');
    return storedData ? JSON.parse(storedData) : null;
  });
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchLiveData = async () => {
      try {
        const response = await axios.get('/api/live', { withCredentials: true });
        const data = response.data;
        
        // Store data in localStorage
        localStorage.setItem('liveData', JSON.stringify(data));

        // Update the state with the fetched data
        setLiveData(data);

      } catch (error) {
        console.error('Error fetching live data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchLiveData();
    const intervalId = setInterval(fetchLiveData, 5000); // Update every 5 seconds

    return () => clearInterval(intervalId);
  }, []);

  return { liveData, isLoading };
};

export default LiveDataQuery;
